var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_48_377",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_48_377",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAACYElEQVRYhe1WO3ITQRB9Bg6gI4iJCNcZIa7qHPkERieQdQKhkAgREWJnZJZCqrpqrROgE6x1A3QDqHG9qertnVmtMQlVeolqRzPdb17/Bif89xCRd8+5w9lTNovICMAHAO8B5BzfA9gAWKvq/p8SEJGPAGYARgOPrAAsVfXwLAIiMgZwB6Ayy2sAWwA7szamMhOzFlW4VFW7bzgBEYlOa3Pr6HjeJy8JLxiqiKjARYlEkQDjXZubT1X1po+wOx8JfDMkXufC8aLHxuJvnUdw/5SfI0OmhZcF9lHG7/xcqeonrlchhK8hhLdN0/w4RqJpml0I4YwV8yaEsG2aphW+kgIz/kbJlma9ZpJdi8ikcNZjRTsRV/7PEoFkfJ3ixoZjS7BjLAeeT+HrkO4QoPxjfm56bA/tBxG36Qwrq0zAOAc7W4Ivo/lQ764EW8T7qgC2bJyUcI3pKTiqQB+WJqE+ezkHYlAVPMI7YAe0tV2LyDX3TkTkt4j84tywdmxYW82oQ0BVbdw7E09VYzu+pKERlXgwjSauLRKxjJ1WLpUUWPM3W2okcWGMjY9URbKz8+24RCCVX1VqODGzVfWcIfHDKfaP2IBS/0gKfPF2+obRA29WHCRuf0UV9mlacqD9pJ24du7tvOqxuU8EjjlHt9btNE0JOB88DZ1st8ng0LIz74i0f8W86SAbAhGpDYEbGqrM9yZnkI5n5jHyuF9Vp35vQocAb18Pualr1b5kD3xHZG+ekMuBhfve09GW8bwycc29jA/M9tWQ3GkpwNvfGYfZ5zWl9uM5Orvve4CecEIHAP4A0oTw6B+9boEAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.c548d0cb0811a2012e69e42eed150912.svg";
export { ForwardRef as ReactComponent };